function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { initializerDefineProperty as _initializerDefineProperty, applyDecoratedDescriptor as _applyDecoratedDescriptor } from "../_virtual/_rollupPluginBabelHelpers.js";
import uniq from 'lodash.uniq';
import { observable, computed, action } from 'mobx';
import { mapAssignmentKeyToParties } from "../helpers/fieldAssignment.js";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var AssignmentStore = (_class = (_temp =
/*#__PURE__*/
function () {
  function AssignmentStore(pdfStore) {
    _classCallCheck(this, AssignmentStore);

    this.pdfStore = void 0;

    _initializerDefineProperty(this, "options", _descriptor, this);

    _initializerDefineProperty(this, "setOptions", _descriptor2, this);

    _initializerDefineProperty(this, "findOptionByKey", _descriptor3, this);

    _initializerDefineProperty(this, "findOptionsByType", _descriptor4, this);

    this.pdfStore = pdfStore;
  }

  _createClass(AssignmentStore, [{
    key: "defaultOption",
    get: function get() {
      return this.options.find(Boolean);
    }
  }, {
    key: "assignmentTypes",
    get: function get() {
      return uniq(this.options.map(function (option) {
        return option.assignmentType;
      }));
    }
  }, {
    key: "updatePartyAssignments",
    value: function updatePartyAssignments(field, assignedTo) {
      if (field.data.dataType === 'autofill') return;
      var parties = mapAssignmentKeyToParties(assignedTo, this.pdfStore.documentPartyMappings);
      field.updateData({
        parties: parties,
        value: undefined,
        fontSize: undefined
      });
    }
  }]);

  return AssignmentStore;
}(), _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "options", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "defaultOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "assignmentTypes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "assignmentTypes"), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "setOptions", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this = this;

    return function (options) {
      _this.options = options;
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "findOptionByKey", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (key) {
      return _this2.options.find(function (option) {
        return option.assignmentKey === key;
      });
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "findOptionsByType", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (type) {
      return _this3.options.filter(function (option) {
        return option.assignmentType === type;
      });
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "updatePartyAssignments", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updatePartyAssignments"), _class.prototype)), _class);
export default AssignmentStore;